import { create } from 'zustand';

export interface AutoInputFile {
  url: string;
  name?: string;
  mimeType?: string;
  fileId?: string;
  preserveMultimodal?: boolean;
}

interface AutoInputState {
  /** 自动输入的内容 */
  content: string | null;
  /** 自动输入所属项目；未设置时兼容不绑定项目的通用自动输入。 */
  targetProjectId?: string;
  /** 自动输入提交后展示在消息列表里的文本；不影响真实请求内容 */
  displayContent?: string;
  /** 自动输入的文件列表 */
  files: AutoInputFile[];
  /** 是否已完成自动输入 */
  hasCompleted: boolean;
  /** 设置自动输入内容 */
  setContent: (
    content: string | null,
    files?: AutoInputFile[],
    displayContent?: string,
    targetProjectId?: string,
  ) => void;
  /** 当前项目是否允许消费这条自动输入。 */
  isTargetProject: (projectId: string) => boolean;
  /** 标记自动输入已完成 */
  markAsCompleted: () => void;
  /** 重置状态 */
  reset: () => void;
}

function getInitialState() {
  return {
    content: null,
    targetProjectId: undefined,
    displayContent: undefined,
    files: [],
    hasCompleted: false,
  };
}

function normalizeAutoInputFiles(files: AutoInputFile[]): AutoInputFile[] {
  return files.filter(file => Boolean(file.url));
}

export const useAutoInputStore = create<AutoInputState>((set, get) => ({
  ...getInitialState(),

  setContent: (content, files = [], displayContent, targetProjectId) => set({
    content,
    files: normalizeAutoInputFiles(files),
    displayContent,
    targetProjectId,
  }),
  isTargetProject: projectId => !get().targetProjectId || get().targetProjectId === projectId,
  markAsCompleted: () => set({ hasCompleted: true }),
  reset: () => set(getInitialState()),
}));
